module.exports = __webpack_public_path__ + "img/gaslp_app.fcfa38ee.svg";